/*=========================================================================================
  File Name: moduleAuth.js
  Description: Auth Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './modulePersonasState.js'
import mutations from './modulePersonasMutations.js'
import actions from './modulePersonasActions.js'
import getters from './modulePersonasGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
